// SEND-144 (Howard ruled 2026-08-28) — CANDIDATE EDGES ON A BODY ZONE.
// The bottom edge is where starter would run, the verticals are where the
// corners would be, the top is the eave/frieze line.
//
// SEND-210 (Howard ruled 2026-08-14) — NOTHING IS PAINTED ON THE PHOTO ANY
// MORE. "He does not need corner / starter / eave candidate words drawn on
// the photo. Not dimmed. Not there." The three WORDS are gone from the
// picture AND so are the amber dashed lines they sat on — a nameless dashed
// line only re-outlines a zone he drew himself.
//
// THE DATA IS KEPT, NOT DELETED. `candidateEdges` still derives where each
// candidate would run, from the zone's own four points, and the component is
// still mounted in the editor. What changed is that it RENDERS NOTHING.
// It stores nothing, deletes nothing, moves no quantity and never carried a
// length, an LF or a key — starter, corners, soffit and fascia are still
// named refusals until he draws the line himself.
import React from "react";

export const candidateEdges = (pts) => {
  const [tl, tr, br, bl] = pts;
  return [
    { key: "starter", a: bl, b: br },
    { key: "corner-left", a: tl, b: bl },
    { key: "corner-right", a: tr, b: br },
    { key: "eave", a: tl, b: tr },
  ];
};

// SEND-210 — PAINTS NOTHING. Kept mounted so the data path stays named and
// reachable; the photo is left alone.
export const CandidateEdges = () => null;

export default CandidateEdges;
